import { ActionTypes } from "../constants/actionTypes";

export const setActiveUser = (data) => {
  return {
    type: ActionTypes.SET_ACTIVEUSER,
    payload: data,
  };
};
